import { formatDate } from 'shared/lib/formatDate';
import { theme } from 'shared/styles/theme';
import { Typography } from 'shared/ui/Typography';

type Props = {
  checkpointEnd: string;
  checkpointNumber: string;
  mentorName?: string;
  managerName?: string;
  title?: string;
  date?: string;
};

export const AdaptationFeedbackTodo = ({ checkpointNumber, checkpointEnd, title, date, mentorName, managerName }: Props) => (
  <Typography fontSize={theme.fontSizes['17']}>
    <Typography fontWeight={theme.fontWeights.bold} color={theme.colors.gray800} display='inline'>
      {formatDate(checkpointEnd)}{' '}
    </Typography>
    у новичка{' '}
    <Typography fontWeight={theme.fontWeights.bold} color={theme.colors.gray800} display='inline'>
      {title}{' '}
    </Typography>
    закончится{' '}
    <Typography fontWeight={theme.fontWeights.bold} color={theme.colors.gray800} display='inline'>
      {checkpointNumber}{' '}
    </Typography>
    кт. {date && 'До'}{' '}
    {date && (
      <Typography fontWeight={theme.fontWeights.bold} color={theme.colors.gray800} display='inline'>
        {date}{' '}
      </Typography>
    )}
    сформируй свою оценку и синхронизируйся с {mentorName ? 'наставником' : 'менеджером'}{' '}
    <Typography fontWeight={theme.fontWeights.bold} color={theme.colors.gray800} display='inline'>
      {mentorName || managerName}{' '}
    </Typography>
    о динамике движения новичка{' '}
  </Typography>
);
